import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import {SHA256} from 'crypto-js';
import {emailFormat, passEquals, passFormat} from 'src/app/components/common/validations';
import {DialogService} from 'src/app/services/dialog.service';
import {SessionService} from 'src/app/services/session.service';
import {Constants} from '../../common/constants';
import {ActivatedRoute, Router} from '@angular/router';
import {DeviceDetectorService} from 'ngx-device-detector';
import {RecaptchaErrorParameters} from 'ng-recaptcha';
import {CookieService} from 'ngx-cookie-service';
import {PaymentData} from '../../../models/application/payment-data.model';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements AfterViewInit, OnDestroy, OnInit {
    public hide = true;
    public form: FormGroup;
    public formPass: FormGroup;
    public formRecovery: FormGroup;
    products: PaymentData[] = [];
    changePass = false;
    public initText = false;
    private ngUnsubscribe = new Subject<void>();
    recoveryPassword = false;
    captcha = false;
    token = '';
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;

    constructor(
        private cookieService: CookieService,
        private fb: FormBuilder,
        private service: SessionService,
        private dialogService: DialogService,
        private router: Router,
        private deviceService: DeviceDetectorService,
        private route: ActivatedRoute
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        window.scrollTo(0, 0);
        this.initForm();

        if (this.inSession() && this.userDataM() !== null) {
            this.router.navigate(['/']);
        }

        this.route.queryParams
            .subscribe(params => {
                    if (params.tkbackoffice !== undefined && params.tkbackoffice !== '' && params.tkbackoffice !== null) {
                        this.token = Constants.getdecryptData(params.tkbackoffice, Constants.configSession.userP);
                        this.getSessionBackoffice(
                            this.token
                        );
                    }
                }
            );
    }

    getSessionBackoffice(token: any): void {

        this.service.setAuthData({
            access_token: token,
            token_type: 'bearer',
            refresh_token: '',
            expires_in: 43199,
            scope: 'profile',
            jti: ''
        });

        this.service.infoUsuario().subscribe(
            infoUser => {
                if (infoUser.success) {
                    this.service.setPaymentAccount({
                        user: infoUser.data.username,
                        name: infoUser.data.name,
                        lastName: infoUser.data.lastName,
                        secondLastName: infoUser.data.secondLastName,
                        phone: infoUser.data.phone.length === 10 ? infoUser.data.phone :
                            infoUser.data.phone.length === 9 ? '0' + infoUser.data.phone :
                                infoUser.data.phone.length === 8 ? '00' + infoUser.data.phone : '0000000000',
                        email: infoUser.data.email,
                        isCompany: infoUser.data.isCompany
                    });
                    this.service.setLoginSession(token.substring(0, 18));
                    this.router.navigate(['/']);
                } else {
                    this.service.setLoginSession(null);
                    this.service.setAuthData(null);
                    this.service.setPaymentAccount(null);
                }
            }, () => {
                this.dialogService.showNotificationDialog('Ups!', 'Ocurrio un error inesperado intenta más tarde.');
                this.service.setLoginSession(null);
                this.service.setAuthData(null);
                this.service.setPaymentAccount(null);
                this.router.navigate(['/']);
            }
        );
    }

    inSession(): boolean {
        const auth = this.service.getAuthData();
        const sess = this.service.getLoginSession();
        return (auth != null && sess != null && auth !== '' && sess !== '' && auth !== 'null' && sess !== 'null');
    }

    userDataM(): any {
        return this.service.getPaymentAccount();
    }

    ngOnInit(): void {
        this.products = this.service.getCartItems();
    }

    ngAfterViewInit(): void {
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    recoveryPass(): void {
        this.service.resetPassword(this.formRecovery.controls.email.value).subscribe(
            responseRecovery => {
                if (responseRecovery.success) {
                    this.formRecovery.reset();
                    this.recoveryPassword = false;
                    this.dialogService.showNotificationDialog('Notificación',
                        'Se envió un correo electrónico para recuperar tu contraseña.');
                } else {
                    this.dialogService.showNotificationDialog('Ups!', responseRecovery.error);
                }
            },
            () => {
                this.dialogService.showNotificationDialog('Ups!', 'Ocurrio un error inesperado intenta más tarde.');
            }
        );
    }

    initForm(): void {
        this.form = this.fb.group({
            email: ['', Validators.compose([Validators.required, emailFormat])],
            password: ['', Validators.compose([Validators.required])],
        });
        this.formPass = this.fb.group({
            email: ['', Validators.compose([emailFormat])],
            passNew: ['', Validators.compose([Validators.required, Validators.minLength(13), passFormat])],
            passRepit: ['', Validators.compose([Validators.required, passFormat])],
        }, {
            validators: passEquals,
        });
        this.formRecovery = this.fb.group({
            email: ['', Validators.compose([Validators.required, emailFormat])]
        });
    }

    checarSiSonIguales(): boolean {
        return this.formPass.hasError('passEquals') &&
            this.formPass.get('passNew').dirty &&
            this.formPass.get('passRepit').dirty;
    }

    login(): void {
        if (this.form.valid) {
            this.service.login(this.form.controls.email.value, this.form.controls.password.value).subscribe(
                response => {
                    if (response.access_token) {
                        this.service.setAuthData(response);
                        this.service.setLoginSession(response.access_token.substring(0, 18));
                        this.service.infoUsuario().subscribe(
                            responseValidEmail => {
                                if (responseValidEmail.success) {
                                    this.changePass = responseValidEmail.data.changePassword;
                                    if (!this.changePass) {
                                        this.service.setPaymentAccount({
                                            user: responseValidEmail.data.username,
                                            name: responseValidEmail.data.name,
                                            lastName: responseValidEmail.data.lastName,
                                            secondLastName: responseValidEmail.data.secondLastName,
                                            phone: responseValidEmail.data.phone.length === 10 ? responseValidEmail.data.phone :
                                                responseValidEmail.data.phone.length === 9 ? '0' + responseValidEmail.data.phone :
                                                    responseValidEmail.data.phone.length === 8 ? '00' + responseValidEmail.data.phone : '0000000000',
                                            email: responseValidEmail.data.email,
                                            isCompany: responseValidEmail.data.isCompany
                                        });
                                        switch (this.products.length) {
                                            case 0:
                                                window.open(Constants.BACKOFFICE_URL
                                                    + this.service.getEncryptedData(response.access_token,
                                                        Constants.configSession.userP), '_self');
                                                break;
                                            case 1:
                                                this.router.navigate(['/comprar-firma-digital']);
                                                break;
                                        }
                                    } else {
                                        this.service.setLoginSession(null);
                                    }
                                }
                            }
                        );
                    } else {
                        this.dialogService.showNotificationDialog('Te equivocaste.', 'Usuario y/o contraseña inválidos');
                    }
                },
                error => {
                    switch (error.error.error_description) {
                        case 'User account is locked':
                            this.dialogService.showNotificationDialog('Ups!',
                                'Tu cuenta ha sido bloqueada, ponte en contacto con soporte.');
                            break;
                        case 'Bad credentials':
                            this.dialogService.showNotificationDialog('Ups!',
                                'Usuario y/o contraseña inválidos.');
                            break;
                        case 'Credenciales err&oacute;neas':
                            this.dialogService.showNotificationDialog('Ups!',
                                'Usuario y/o contraseña inválidos.');
                            break;
                        default:
                            this.dialogService.showNotificationDialog('Ups!',
                                'Tenemos problemas, intenta más tarde.');
                            break;
                    }
                }
            );
        } else {
            this.dialogService.showNotificationDialog('Ups!', 'Todos los campos son requeridos.');
        }
    }

    changePassword(): void {
        this.formPass.controls.email.setValue(this.form.controls.email.value);
        if (this.formPass.valid) {
            const request = {
                username: this.formPass.controls.email.value,
                newPass: SHA256(this.formPass.controls.passNew.value).toString(),
                newPassRetype: SHA256(this.formPass.controls.passRepit.value).toString()
            };
            this.service.saveResetPassword(request).subscribe(
                () => {
                    this.dialogService.showNotificationDialog('Listo!', 'Cambiaste con éxito tu contraseña.');
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000);
                }
            );
        } else {
            this.dialogService.showNotificationDialog('Ups!', 'Todos los campos son requeridos.');
        }
    }

    createAccount(): void {
        this.service.setInitText(true);
        setTimeout(() => {
            if (this.router.url === '/firma-digital-gratis') {
                this.service.emitNewSessionText(true);
            } else {
                this.router.navigate(['/firma-digital-gratis']);
            }
        }, 200);
    }

    public resolved(captchaResponse: string): void {
        this.captcha = true;
    }

    public onError(errorDetails: RecaptchaErrorParameters): void {
        this.dialogService.showNotificationDialog('Ups!', 'Error en el reCAPTCHA inténtanlo una vez más.');
    }

}
